export default "__VITE_ASSET__B8Tw4oNg__"